import { Signup } from "pages/Signup/Signup";

export default Signup;
